import { EntityDiagramKind } from '@/types/schema';
import { UnreachableError } from '@/utils/errors';

import { EntityDiagramVariant } from './types';

export function mapEntityDiagramVariantToKind(
  variant: EntityDiagramVariant
): EntityDiagramKind {
  switch (variant) {
    case EntityDiagramVariant.Dispositions:
      return EntityDiagramKind.Dispositions;
    case EntityDiagramVariant.Ownership:
      return EntityDiagramKind.Ownership;
    case EntityDiagramVariant.GratTerm:
      return EntityDiagramKind.GratTerm;
    case EntityDiagramVariant.QprtTerm:
      return EntityDiagramKind.QprtTerm;
    case EntityDiagramVariant.CrtTerm:
      return EntityDiagramKind.CrtTerm;
    case EntityDiagramVariant.CltTerm:
      return EntityDiagramKind.CltTerm;
    default:
      throw new UnreachableError({
        case: variant,
        message: `Unknown EntityDiagramVariant: ${variant}`,
      });
  }
}
